import { updatesData } from '@/mocks/homeData';

const typeConfig: Record<string, { icon: string; color: string }> = {
  update: { icon: 'ri-refresh-line', color: 'text-primary-500 bg-primary-100' },
  new: { icon: 'ri-sparkling-line', color: 'text-accent-500 bg-accent-100' },
  system: { icon: 'ri-settings-3-line', color: 'text-secondary-500 bg-secondary-100' },
  event: { icon: 'ri-calendar-event-line', color: 'text-primary-500 bg-primary-100' },
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            平台更新公告、新片上线与活动资讯一览
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updatesData.map((item) => {
              const config = typeConfig[item.type] || typeConfig.update;
              return (
                <div key={item.id} className="relative pb-8 last:pb-0">
                  <div
                    className={`absolute -left-[25px] w-12 h-12 rounded-xl flex items-center justify-center ${config.color}`}
                  >
                    <i className={`${config.icon} text-lg`}></i>
                  </div>
                  <div className="ml-8">
                    <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                    <p className="text-sm font-semibold text-foreground-900 mt-1">{item.title}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}